<template>
    <div class="modal-wrapper" :class="{ hide: !modals.openNewTabDeposits }" v-on:click.stop="hideModal">
        <div class="modal ElevationDark__3" v-on:click.stop>
            <BaseModalTitle class="title">
                <template #left>
                    <h4 class="title__large">{{ 'Open in a new tab ?' }}</h4>
                </template>
                <template #right>
                    <BaseToggleIconButton 
                        class="cross-icon" 
                        :button-style="'secondary'" 
                        @click.native="hideModal">
                            <template #icon>
                                <i class="material-icons">close</i>
                            </template>
                    </BaseToggleIconButton>
                </template>
            </BaseModalTitle>
            <span class="url body__medium">
                {{ modalOpenNewTabDeposits.url }}
            </span>
            <div class="row actions">
                <BaseButton 
                    :button-style="'outlined-primary'" 
                    @click.native="copyUrl()"
                >
                    <template #icon>
                        <i class="material-symbols-outlined">content_copy</i>
                    </template>
                </BaseButton>
                <BaseButton 
                    :button-style="'filled-primary'" 
                    :button-text="'Open New Tab'"
                    @click.native="openNewTab()"
                />
                
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { MODAL, MODAL_OPEN_NEW_TAB_DEPOSIT, NOTIFICATION } from '@/store/mutations.type'
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton.vue";
import BaseToggleIconButton from "@/new-design/shared/ui/buttons/BaseToggleIconButton.vue";
import BaseModalTitle from "@/new-design/shared/ui/titles/BaseModalTitle.vue";

export default {
    name: "OpenNewTabDeposits",
    components: { BaseButton, BaseModalTitle, BaseToggleIconButton },
    methods: {
        hideModal() {
            this.$store.commit(MODAL, {
                openNewTabDeposits: false
            })
            this.$store.commit(MODAL_OPEN_NEW_TAB_DEPOSIT, null)
        },
        copyUrl() {
            let url = this.modalOpenNewTabDeposits.url;

            if(url){
                navigator.clipboard.writeText(url)
                    .then(() => {
                        this.$store.commit(NOTIFICATION, 'Address copied to clipboard')
                    })
                    .catch(() => {
                    })
            }
        },
        openNewTab() {
            let url = this.modalOpenNewTabDeposits.url;

            if(url){
                let win = window.open(url, '_blank');
                if (win) {
                    win.focus()
                }
            }

            this.hideModal()
        },
    },
    computed: {
        ...mapGetters(['modals', 'tokens','modalOpenNewTabDeposits']),
    },
    watch: {
        modals: {
            deep: true,
            handler(newVal) {
                if(newVal.openNewTabDeposits){
                    this.copyUrl();
                }
            }
        }
    }
}
</script>

<style scoped>
.modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    width: 360px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: var(--System-Surface3);
    border-radius: var(--Corner-small);
    z-index: 1100;
}

.title {
    padding: 24px;
    color: var(--System-OnSurface);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.url {
    padding: 0 24px;
    word-break: break-all;
    color: var(--System-OnSurfaceVariant);
}

.row {
    overflow: hidden;
    align-items: stretch;
    flex-wrap: nowrap;
    gap: 8px;
}

.symbol-content {
    padding: 24px 24px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.price-info,
.symbol-info {
    display: flex;
    align-items: center;
}

.price-info {
    gap: 10px;
}

.symbol-info {
    gap: 12px;
}

.symbol {
    zoom: 0.4;
}

.alias,
.profit {
    color: var(--System-OnSurface);
}

.actions {
    justify-content: space-between;
    padding: 24px;
    margin-top: 24px;
    border-top: 1px solid var(--System-OutlineVariant);
}

@keyframes l3 {
    to {
        transform: rotate(1turn)
    }
}

@keyframes l2 {
    to {
        transform: rotate(1turn)
    }
}
</style>
